// src/theme.js
import { createTheme } from "@mui/material/styles";

const setMode = "dark"; // Default mode

// Brand color constants — use these everywhere, never hardcode elsewhere
export const BRAND_COLORS = {
  purple: "#5F5AA2",       // FlyBnB primary — the combination of flight + stay
  coral:  "#FF5A5F",       // Stays / Airbnb
  blue:   "#07a1fc",       // Flights
  purpleLight: "#8B7CF6",  // AI Explore accent — lighter purple, monochromatic
};

export const GRADIENTS = {
  brand:     "linear-gradient(45deg, #5F5AA2 30%, #FF5A5F 90%)",   // CTAs, hero title, headings
  brandRev:  "linear-gradient(45deg, #FF5A5F 30%, #5F5AA2 90%)",   // Search button, reversed
  explore:   "linear-gradient(135deg, #5F5AA2 0%, #8B7CF6 100%)",  // AI Explore tab
  exploreHover: "linear-gradient(135deg, #4A4580 0%, #7B6BD4 100%)", // AI Explore hover
};

export const getTheme = (mode = setMode) => {
  // Resolve "system" mode to either "light" or "dark"
  const resolvedMode =
    mode === "system"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
      : mode;

  return createTheme({
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    palette: {
      mode: resolvedMode, // ✅ Using resolvedMode to ensure a valid theme mode
      background: {
        default: resolvedMode === "dark" ? "#121212" : "#f8f8f8",
        paper: resolvedMode === "dark" ? "#1d1d1d" : "#ffffff",
      },
      primary: {
        main: "#5F5AA2", // No need for condition since it's the same in both modes
        secondary: resolvedMode === "dark" ? "#121212" : "#e3f2fd",
        flight: "#07a1fc",
        stay: "#FF5A5F",
      },
      text: {
        primary: resolvedMode === "dark" ? "#ffffff" : "#000000",
        secondary: resolvedMode === "dark" ? "#aaaaaa" : "#333333",
      },
    },
    custom: {
      logo:
        resolvedMode === "dark"
          ? "./logo/dark-main-logo.svg"
          : "./logo/light-main-logo.svg",
      navbar: resolvedMode === "dark" ? "#1f1f1f" : "#ffffff",
      searchTypeImages: {
        flightsAndStays: {
          selected: "./icons/bothwhite-icon.svg",
          unselected: "./icons/bothblack-icon.svg",
        },
        staysOnly: {
          selected: "./icons/staywhite-icon.svg",
          unselected: "./icons/stayblack-icon.svg",
        },
      },
    },
  });
};
